<template>
  <div v-if="isPC" class="guide guide-pc">
    <div class="start">
      <h2>{{ $t('Home.Components.RegisterRoute.StartSellingForFree') }}</h2>
      <div class="subheading">{{ $t('Home.Components.RegisterRoute.Tips1') }}</div>
      <div v-if="userId" class="register">
        <div style="margin: 0 auto">
          <el-button type="primary" @click="jump('/mall')">{{ $t('Home.Components.RegisterRoute.StartSelling') }}</el-button>
        </div>
      </div>
      <div v-else class="register">
        <div>
          <el-input :placeholder="$t('Home.Components.RegisterRoute.EnterYourEmail')" v-model="email" />
          <el-button type="primary" @click="sendEmail">{{ $t('Home.Components.RegisterRoute.SignUpForFree') }}</el-button>
        </div>
        <span class="privacy">{{ $t('Home.Components.RegisterRoute.Tips2') }} <span>{{ $t('Home.Components.RegisterRoute.Tips3') }}</span></span>
      </div>
    </div>
  </div>
  <div v-else class="guide guide-Mobile" :style="{height: userId?'290px':'356px'}">
    <h2>{{ $t('Home.Components.RegisterRoute.StartSellingForFree') }}</h2>
    <div class="subheading">{{ $t('Home.Components.RegisterRoute.Tips1') }}</div>
    <template v-if="userId">
      <el-button type="primary" style="margin-top:30px" @click="jump('/mall')">{{ $t('Home.Components.RegisterRoute.StartSelling') }}</el-button>
    </template>
    <template v-else>
      <el-input v-model="email" :placeholder="$t('Home.Components.RegisterRoute.YourEmail')" />
      <el-button type="primary" @click="sendEmail">{{ $t('Home.Components.RegisterRoute.SignUpForFree') }}</el-button>
      <p class="privacy">{{ $t('Home.Components.RegisterRoute.Tips2') }} <span>{{ $t('Home.Components.RegisterRoute.Tips3') }}</span></p>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: ''
    }
  },
  computed: {
    userId() {
      return this.$store.state.common.userId
    }
  },
  methods: {
    jump(path, event_id) {
      if (['/mall'].includes(path)) {
        window.open(process.env.VUE_APP_MAIN_DOMAIN + path)
        return
      }
      this.$router.push(path)
    },
    sendEmail() {
      this.$router.push({
        name: '/register',
        params: {
          email: this.email
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.guide-pc {
  background-image: url('https://img.kakaclo.com/web-img/home/frame.png'), url('https://img.kakaclo.com/web-img/home/frame2.png'), url('https://img.kakaclo.com/web-img/home/sales-volume.png');
  background-repeat: no-repeat, no-repeat;
  background-size: 149px 91px, 149px 91px, 100% 100%;
  background-position: left 15px, right 265px, left top;
}
.guide-Mobile{
  background-image: url('https://img.kakaclo.com/web-img/home/guide-mobile.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  h2{
    height: 25px!important;
  }
}
.guide {
  position: relative;
  height: 356px;
  padding: 56px 25px 50px;
  h2 {
    height: 52px;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    color: #000000;
  }
  .subheading {
    height: 30px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 30px;
    color: #556987;
    margin: 12px 0;
  }
  /deep/.el-input__inner {
    height: 48px;
    border: 0.5px solid #8b93a3;
    border-radius: 4px;
  }
  .el-button {
    color: #fff;
    height: 50px;
    width: 100%;
    margin: 13px 0 8px;
    background: #99c41c;
    border-radius: 4px;
  }
  .privacy {
    height: 20px;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.05em;
    color: #6b7280;
    span {
      color: #99c41c;
      cursor: pointer;
    }
  }

  .start {
    position: absolute;
    top: 88px;
    left: 50%;
    width: 672px;
    height: 194px;
    transform: translateX(-50%);
    h2 {
      font-style: normal;
      color: #2a3342;
      font-weight: 700;
      font-size: 36px;
      line-height: 44px;
      text-align: center;
      letter-spacing: -0.02em;
      transform: rotate(0.01deg);
    }
    .subheading {
      font-style: normal;
      color: #556987;
      font-weight: 500;
      font-size: 20px;
      line-height: 30px;
      text-align: center;
      margin-top: 15.83px;
    }

    .register {
      display: flex;
      width: 518px;
      margin: 0 auto;
      margin-top: 31px;
      flex-direction: column;
      .el-input {
        width: 320px;
        height: 46px;
        /deep/.el-input__inner {
          width: 320px;
          height: 46px;
          background: #ffffff;
          border: 1px solid #d5dae1;
          box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
          border-radius: 8px;
        }
      }
      .el-button {
        width: 183px;
        height: 46px;
        color: #fff;
        padding: 9px 18px;
        margin-left: 15px;
        background: #99c41c;
        box-shadow: 0px 1px 2px rgba(105, 81, 255, 0.05);
        border-radius: 6px;
      }
      .privacy {
        margin-top: 8px;
        // font-family: 'Poppins';
        color: #556987;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        span {
          color: #99c41c;
        }
      }
    }
  }
}
</style>
